(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderbagListByServiceController', OrderbagListByServiceController);

    OrderbagListByServiceController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate'];

    function OrderbagListByServiceController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';


        vm.orderBagStatusList = null;
        vm.orderBagStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        loadAll()

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

        }

        function confirm() {

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;
            var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
